import React from "react";

const Maize = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Maize</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>HHM - 4 (Hybrid)</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>
                Suitable for timely sowing in Rabi as well as Kharif season.
              </td>
              <td>
                In irrigated areas, light irrigation at the time of flowering
                and formation of seeds.
              </td>
              <td>85-87 days.</td>
              <td>
                Plant height is around 175-210 cm. Earhead length is around
                17.5-18.5 cm and thickness is around 4.2-4.6 cm. Seeds are round
                and deep orange coloured.
              </td>
              <td>24 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HQPM - 1 [Released in 25.08.2005]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>
                Suitable for timely sowing in Rabi as well as Kharif season.
              </td>
              <td>
                In irrigated areas, light irrigation at the time of flowering
                and formation of seeds.
              </td>
              <td>88-90 days.</td>
              <td>
                Plant height is around 175-210 cm. Earhead length is around
                18.5-19 cm and thickness is around 4.1-4.2 cm. Seeds are round
                and deep orange coloured.
              </td>
              <td>25 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Maize;
